import React, {PropsWithChildren} from "react";
import {ChatFooter as ChatFooterUI} from "@unibuddy/chat-ui";
import {View} from "@unibuddy/patron";
import {useScreensizeContext} from "../../../../providers/ScreensizeProvider";

export const ChatFooter = ({children}: PropsWithChildren) => {
    const {isSmallDeviceDimension} = useScreensizeContext();
    return (
        <View
            paddingX="xxsmall"
            bgColor="grey50"
            paddingBottom={isSmallDeviceDimension ? "none" : "xxsmall"}
        >
            <ChatFooterUI>{children}</ChatFooterUI>
        </View>
    );
};
